// {
//   "name": "iconic-shoppable-stories-first.js",
//   "author": "Arham Web Works",
//   "description": "Copying in any form is strictly prohibited. Any instance of copying will be subject to legal action and accountability under the law."
// }

(() => {
  const CART_ADD_URL =
    (window.routes && window.routes.cart_add_url) || "/cart/add.js";
  const CART_URL = (window.routes && window.routes.cart_url) || "/cart";

  window.addEventListener("pageshow", function (event) {
    if (
      event.persisted ||
      (window.performance &&
        window.performance.navigation &&
        window.performance.navigation.type === 2)
    ) {
      window.location.reload();
    }
  });

  const getActiveCurrency = () =>
    (window.Shopify &&
      window.Shopify.currency &&
      window.Shopify.currency.active) ||
    document.documentElement.getAttribute("data-currency") ||
    "USD";

  const formatMoney = (cents) =>
    new Intl.NumberFormat(undefined, {
      style: "currency",
      currencyDisplay: 'narrowSymbol', 
      currency: getActiveCurrency(),
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(cents / 100);

    
  const buildPriceHTML = (variant) => {
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      return `
        <s class="iconic-price-item iconic-price-item-regular">
          ${formatMoney(variant.compare_at_price)}
        </s>
        <span class="iconic-price-item iconic-price-item-sale">
          ${formatMoney(variant.price)}
        </span>
      `;
    }
    return `
      <span class="iconic-price-item">
        ${formatMoney(variant.price)}
      </span>
    `;
  };

  if (!document.querySelector("iconic-shoppable-stories-first")) return;

  if (!customElements.get("iconic-video")) {
    customElements.define(
      "iconic-video",
      class IconicVideo extends HTMLElement {
        constructor() {
          super();
          this.nativeVideo = null;
          this.iframe = null;
          this.iframeSrc = "";
          this.variantData = null;
          this.variantListenerAttached = false;
        }

        connectedCallback() {
          requestAnimationFrame(() => {
            this.productForm = this.querySelector(
              "iconic-shoppable-product-form"
            );
            this.productFormInput =
              this.productForm?.querySelector('input[name="id"]') || null;
            this.submitButton = this.productForm?.querySelector(
              'button[type="submit"]'
            );
            this.priceElement = this.querySelector(".iconic-price");
            this.nativeVideo = this.querySelector("video");
            this.iframe = this.querySelector("iframe");
            this.iframeSrc = this.iframe ? this.iframe.getAttribute("src") : "";

            this.sectionId = this.dataset.sectionId;
            this.videoTrigger = this.querySelector(
              ".iconic-shoppable-stories-video"
            );
            this.popup = document.getElementById(
              `iconic-stories-popup-${this.sectionId}`
            );

            if (this.videoTrigger && this.popup) {
              this.videoTrigger.addEventListener("click", () => {
                this.popup.classList.add("is-visible");
                document.body.classList.add("body-no-scroll");
              });

              if (!this.popup.dataset.listenersAttached) {
                const closeBtn = this.popup.querySelector(
                  ".iconic-popup-close"
                );
                const popupElement = this.popup;
                const closePopup = () => {
                  popupElement.classList.remove("is-visible");
                  document.body.classList.remove("body-no-scroll");
                };
                if (closeBtn) closeBtn.addEventListener("click", closePopup);
                popupElement.addEventListener("click", (event) => {
                  if (event.target === popupElement) closePopup();
                });
                this.popup.dataset.listenersAttached = "true";
              }
            }

            const stopClick = (event) => event.stopPropagation();
            this.querySelectorAll(".iconic-variants-button").forEach((button) =>
              button.addEventListener("click", stopClick)
            );
            this.querySelectorAll(".iconic-product-variant-wrapper").forEach(
              (wrapper) => wrapper.addEventListener("click", stopClick)
            );

            if (this.dataset.playOnHover === "true") {
              this.playHandler = this.playVideo.bind(this);
              this.pauseHandler = this.pauseVideo.bind(this);
              this.addEventListener("mouseenter", this.playHandler);
              this.addEventListener("mouseleave", this.pauseHandler);
            }

            this.querySelectorAll(
              ".iconic-variants-button[data-target]"
            ).forEach((buttonWrapper) => {
              const toggleButton = buttonWrapper.querySelector("button");
              if (!toggleButton) return;
              toggleButton.addEventListener("click", () => {
                const targetId = buttonWrapper.dataset.target;
                const targetBox = this.querySelector(
                  `.iconic-product-variant-wrapper[data-target="${targetId}"]`
                );
                if (targetBox) targetBox.classList.toggle("active");

                if (!this.variantListenerAttached) {
                  const variantPicker =
                    this.querySelector("iconic-variant-radios") ||
                    this.querySelector("iconic-variant-selects");
                  if (variantPicker) {
                    const scriptTag = variantPicker.querySelector(
                      "script[type='application/json']"
                    );
                    if (scriptTag) {
                      try {
                        this.variantData = JSON.parse(scriptTag.textContent);
                        variantPicker.addEventListener(
                          "change",
                          this.onVariantChange.bind(this)
                        );
                        this.variantListenerAttached = true;
                      } catch (e) {
                        console.error("Variant JSON parse error:", e);
                      }
                    }
                  }
                }
              });
            });
          });
        }

        disconnectedCallback() {
          if (this.dataset.playOnHover === "true") {
            if (this.playHandler)
              this.removeEventListener("mouseenter", this.playHandler);
            if (this.pauseHandler)
              this.removeEventListener("mouseleave", this.pauseHandler);
          }
        }

        onVariantChange() {
          if (!this.variantData || !this.productForm) return;

          let selectedOptions = [];
          const variantRadios = this.querySelector("iconic-variant-radios");
          if (variantRadios) {
            selectedOptions = Array.from(
              variantRadios.querySelectorAll('input[type="radio"]:checked'),
              (radio) => radio.value
            );
          } else {
            const variantSelects = this.querySelector("iconic-variant-selects");
            if (!variantSelects) return;
            selectedOptions = Array.from(
              variantSelects.querySelectorAll("select.iconic-select-select"),
              (select) => select.value
            );
          }

          const selectedVariant = this.variantData.find((variant) =>
            selectedOptions.every(
              (optionValue, index) => variant.options[index] === optionValue
            )
          );
          if (!selectedVariant) return;

          if (this.productFormInput) {
            this.productFormInput.value = selectedVariant.id;
          }

          if (this.priceElement) {
            this.priceElement.innerHTML = buildPriceHTML(selectedVariant);
          }

          if (this.submitButton) {
            const buttonTextSpan =
              this.submitButton.querySelector("span") || this.submitButton;
            if (selectedVariant.available) {
              this.submitButton.removeAttribute("disabled");
              buttonTextSpan.textContent = "Add to Cart";
            } else {
              this.submitButton.setAttribute("disabled", "disabled");
              buttonTextSpan.textContent = "Sold Out";
            }
          }
        }

        playVideo() {
          if (this.nativeVideo) this.nativeVideo.play().catch(() => {});
          if (this.iframe) {
            if (this.iframeSrc.includes("youtube.com")) {
              const msg = { event: "command", func: "playVideo", args: "" };
              this.iframe.contentWindow?.postMessage(JSON.stringify(msg), "*");
            } else if (this.iframeSrc.includes("vimeo.com")) {
              const msg = { method: "play" };
              this.iframe.contentWindow?.postMessage(msg, "*");
            }
          }
        }

        pauseVideo() {
          if (this.nativeVideo) this.nativeVideo.pause();
          if (this.iframe) {
            if (this.iframeSrc.includes("youtube.com")) {
              const msg = { event: "command", func: "pauseVideo", args: "" };
              this.iframe.contentWindow?.postMessage(JSON.stringify(msg), "*");
            } else if (this.iframeSrc.includes("vimeo.com")) {
              const msg = { method: "pause" };
              this.iframe.contentWindow?.postMessage(msg, "*");
            }
          }
        }
      }
    );
  }

  if (!customElements.get("iconic-shoppable-product-form")) {
    customElements.define(
      "iconic-shoppable-product-form",
      class IconicShoppableProductForm extends HTMLElement {
        constructor() {
          super();
          this.form = this.querySelector("form");
          this.submitButton = this.querySelector('[type="submit"]');
          this.hideErrors = this.dataset.hideErrors === "true";

          if (!this.form || !this.submitButton) return;

          const idInput = this.form.querySelector("[name=id]");
          if (idInput) idInput.disabled = false;

          this.onSubmitHandler = this.onSubmitHandler.bind(this);
          this.form.addEventListener("submit", this.onSubmitHandler);
        }

        onSubmitHandler(evt) {
          evt.preventDefault();
          if (!this.submitButton) return;

          if (this.submitButton.getAttribute("aria-disabled") === "true")
            return;

          this.handleErrorMessage();
          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButton.classList.add("loading");

          const config = {
            method: "POST",
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              Accept: "application/json",
            },
          };

          const formData = new FormData(this.form);
          config.body = formData;

          fetch(CART_ADD_URL, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.handleErrorMessage(
                  response.description || response.message
                );
                this.submitButton.classList.remove("loading");
                this.submitButton.removeAttribute("aria-disabled");
                return;
              }

              // Always redirect to cart page
              window.location.replace(CART_URL);
            })
            .catch((e) => {
              console.error(e);
              this.handleErrorMessage(
                "Something went wrong. Please try again."
              );
            })
            .finally(() => {
              this.submitButton.classList.remove("loading");
              if (!this.error)
                this.submitButton.removeAttribute("aria-disabled");
              if (spinner) spinner.classList.add("hidden");
            });
        }

        handleErrorMessage(errorMessage = false) {
          if (this.hideErrors) return;
          this.errorMessageWrapper =
            this.errorMessageWrapper ||
            this.querySelector(".iconic-product-form-error-message-wrapper");
          if (!this.errorMessageWrapper) return;
          this.errorMessage =
            this.errorMessage ||
            this.errorMessageWrapper.querySelector(
              ".iconic-product-form-error-message"
            );
          this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
          if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
          }
        }
      }
    );
  }

  if (!customElements.get("iconic-stories-popup")) {
    customElements.define(
      "iconic-stories-popup",
      class IconicStoriesPopup extends HTMLElement {
        constructor() {
          super();
          this.variantData = {};
        }

        connectedCallback() {
          requestAnimationFrame(() => {
            this.querySelectorAll(".swiper-slide").forEach((slide) => {
              const radios = slide.querySelector("iconic-variant-radios");
              const selects = slide.querySelector("iconic-variant-selects");
              const picker = radios || selects;
              if (picker) {
                const slideId =
                  slide.getAttribute("data-slide-id") ||
                  slide.id ||
                  Math.random().toString(36).slice(2);
                const scriptTag = picker.querySelector(
                  "script[type='application/json']"
                );
                if (scriptTag) {
                  let data;
                  try {
                    data = JSON.parse(scriptTag.textContent);
                  } catch (e) {
                    console.error(
                      "Could not parse variant JSON for slide:",
                      slideId,
                      e
                    );
                    return;
                  }
                  this.variantData[slideId] = { data, picker, slide };
                  picker.addEventListener("change", () =>
                    this.updateVariant(slideId)
                  );
                  this.updateVariant(slideId);
                }
              }

              const volumeButton = slide.querySelector(
                ".iconic-popup-stories-volume"
              );
              if (volumeButton) {
                let isMuted = true;
                const nativeVideo = slide.querySelector("video");
                const iframe = slide.querySelector("iframe");
                const iframeSrc = iframe ? iframe.getAttribute("src") : "";
                const volumeOnIcon = volumeButton.querySelector(
                  ".iconic-volume-play"
                );
                const volumeOffIcon = volumeButton.querySelector(
                  ".iconic-volume-stop"
                );

                volumeButton.addEventListener("click", () => {
                  isMuted = !isMuted;

                  document.querySelectorAll("video").forEach((vid) => {
                    vid.muted = true;
                    vid.setAttribute("muted", "");
                  });

                  if (nativeVideo) {
                    nativeVideo.muted = isMuted;
                    if (isMuted) {
                      nativeVideo.setAttribute("muted", "");
                    } else {
                      nativeVideo.removeAttribute("muted");
                    }
                  }

                  if (iframe) {
                    if (iframeSrc.includes("youtube.com")) {
                      const command = isMuted ? "mute" : "unMute";
                      const msg = { event: "command", func: command, args: "" };
                      iframe.contentWindow.postMessage(
                        JSON.stringify(msg),
                        "*"
                      );
                    } else if (iframeSrc.includes("vimeo.com")) {
                      const volume = isMuted ? 0 : 1;
                      const msg = { method: "setVolume", value: volume };
                      iframe.contentWindow.postMessage(msg, "*");
                    }
                  }

                  if (isMuted) {
                    if (volumeOnIcon)
                      volumeOnIcon.classList.add("iconic-d-none");
                    if (volumeOffIcon)
                      volumeOffIcon.classList.remove("iconic-d-none");
                  } else {
                    if (volumeOnIcon)
                      volumeOnIcon.classList.remove("iconic-d-none");
                    if (volumeOffIcon)
                      volumeOffIcon.classList.add("iconic-d-none");
                  }
                });
              }
            });
          });
        }

        updateVariant(slideId) {
          const variantInfo = this.variantData[slideId];
          if (!variantInfo) return;

          const { data, picker, slide } = variantInfo;
          let selectedOptions = [];

          if (picker.tagName.toLowerCase() === "iconic-variant-radios") {
            picker
              .querySelectorAll("input[type=radio]:checked")
              .forEach((radio) => {
                selectedOptions.push(radio.value);
              });
          } else {
            picker
              .querySelectorAll("select.iconic-select-select")
              .forEach((select) => {
                selectedOptions.push(select.value);
              });
          }

          const selectedVariant = data.find((variant) =>
            selectedOptions.every(
              (option, index) => variant.options[index] === option
            )
          );

          if (!selectedVariant) return;

          const formWrapper = slide.querySelector(
            "iconic-shoppable-product-form"
          );
          const form = formWrapper?.querySelector("form");
          if (form) {
            form.querySelectorAll('input[name="id"]').forEach((inp) => {
              inp.value = selectedVariant.id;
            });
          }

          const priceEl = slide.querySelector(".iconic-price");
          if (priceEl) {
            priceEl.innerHTML = buildPriceHTML(selectedVariant);
          }

          const button = form?.querySelector('button[type="submit"]');
          const buttonSpan = button?.querySelector("span") || button;
          if (button && buttonSpan) {
            if (selectedVariant.available) {
              button.removeAttribute("disabled");
              buttonSpan.textContent = "Add to Cart";
            } else {
              button.setAttribute("disabled", "disabled");
              buttonSpan.textContent = "Sold Out";
            }
          }
        }
      }
    );
  }


const initSequentialAutoplay = (container) => {
  const sequentialStories = container.querySelectorAll('iconic-video[data-autoplay-sequential="true"]');
  
  if (sequentialStories.length === 0) return;

  let isUserInteracting = false;

  const pauseAllVideos = (exceptThisStory = null) => {
    sequentialStories.forEach(story => {
      if (story !== exceptThisStory) {
        if (typeof story.pauseVideo === 'function') {
          story.pauseVideo();
        } else {
          story.querySelector('video')?.pause();
        }
      }
    });
  };

  sequentialStories.forEach((story, index) => {
    if (story.dataset.sequentialAutoplayInitialized) return;

    const nativeVideo = story.querySelector('video');

    if (nativeVideo) {
      nativeVideo.loop = false; 

      nativeVideo.addEventListener('ended', () => {
        if (isUserInteracting) return;

        const nextIndex = (index + 1) % sequentialStories.length;
        const nextStory = sequentialStories[nextIndex];
        if (nextStory) {
            nextStory.playVideo();
        }
      });

      story.addEventListener('mouseenter', () => {
        isUserInteracting = true;
        pauseAllVideos(story); 
        story.playVideo(); 
      });

      story.addEventListener('mouseleave', () => {
        isUserInteracting = false;
      });

      story.dataset.sequentialAutoplayInitialized = 'true';
    }
  });

  setTimeout(() => {
    if(sequentialStories[0]) {
      sequentialStories[0].playVideo();
    }
  }, 100);
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.shopify-section').forEach(section => {
    if (section.querySelector('iconic-video[data-autoplay-sequential="true"]')) {
       initSequentialAutoplay(section);
    }
  });
});

document.addEventListener('shopify:section:load', (event) => {
  const section = document.getElementById(`shopify-section-${event.detail.sectionId}`);
  if (section && section.querySelector('iconic-video[data-autoplay-sequential="true"]')) {
    initSequentialAutoplay(section);
  }
});
})();
